export default {
    wms: [{
        name: "national",
        type: "wms",
        url: "https://divi.io/wms_proxy/http://sdi.gdos.gov.pl/wms",
        layers: "GDOS:ParkiNarodowe",
        projection: null
    },
    {
        name: "landscape",
        type: "wms",
        url: "https://divi.io/wms_proxy/http://sdi.gdos.gov.pl/wms",
        layers: "GDOS:ParkiKrajobrazowe",
        projection: null
    },
    {
        name: "borders",
        type: "wms",
        url: "https://cbdgmapa.pgi.gov.pl/arcgis/services/midas/MapServer/WMSServer",
        layers: "2",
        projection: "EPSG:4326"
    },
    {
        name: "area",
        type: "wms",
        url: "https://cbdgmapa.pgi.gov.pl/arcgis/services/midas/MapServer/WMSServer",
        layers: "1",
        projection: "EPSG:4326"
    },
    {
        name: "terrain",
        type: "wms",
        url: "https://cbdgmapa.pgi.gov.pl/arcgis/services/midas/MapServer/WMSServer",
        layers: "0",
        projection: "EPSG:4326"
    },
    {
        name: "hypsometry",
        type: "swms",
        url: "https://divi.io/wms_proxy/https://mapy.geoportal.gov.pl/wss/service/wmsimg/guest/ISOK_HipsoDyn/ImageServer/WMSServer",
        layers: "ISOK_HipsoDyn",
        projection: null
    },
    {
        name: "shading",
        type: "wms",
        url: "https://divi.io/wms_proxy/https://mapy.geoportal.gov.pl/wss/service/img/guest/CIEN/MapServer/WMSServer",
        layers: "NMT_100,NMT_30,NMT_5",
        projection: "EPSG:4326"
    },
    {
        name: "buildings",
        type: "wms",
        url: "https://mapy.geoportal.gov.pl/wss/service/pub/guest/G2_BDOT_BUD_2010/MapServer/WMSServer",
        layers: "0,1,2",
        projection: "EPSG:4326"
    },
    {
        name: "kieg",
        type: "wms",
        displayType: "records",
        url: `http://integracja.gugik.gov.pl/cgi-bin/KrajowaIntegracjaEwidencjiGruntow`,
        layers: "dzialki,numery_dzialek",
        projection: "EPSG:3857"
    },
    {
        name: "kiut",
        type: "wms",
        displayType: "records",
        displayName: "Krajowa Integracja Uzbrojenia Terenu",
        visible: false,
        url: `http://integracja.gugik.gov.pl/cgi-bin/KrajowaIntegracjaUzbrojeniaTerenu`,
        layers: "przewod_elektroenergetyczny,przewod_telekomunikacyjny,przewod_wodociagowy,przewod_wodociagowy,przewod_kanalizacyjny,przewod_gazowy,przewod_cieplowniczy,przewod_specjalny",
        marker: "kiut"
    },
    {
        name: "isok",
        type: "wms",
        url: "https://mapy.geoportal.gov.pl/wss/service/pub/guest/G2_ISOK_WMS/MapServer/WMSServer",
        layers: "3,4",
        projection: null
    },
    {
        name: "unemployment",
        type: "wms",
        url: "https://mapy.geoportal.gov.pl/wss/service/pub/guest/G2_bezrobocie_GUS_WMS/MapServer/WMSServer",
        layers: "2,3",
        projection: "EPSG:4326"
    },
    {
        name: "sozo",
        type: "wms",
        url: "https://divi.io/wms_proxy/https://mapy.geoportal.gov.pl/wss/service/img/guest/SOZO/MapServer/WMSServer",
        layers: "Raster",
        projection: "EPSG:4326"
    },
    {
        name: "bdo",
        type: "wms",
        url: "https://mapy.geoportal.gov.pl/wss/service/pub/guest/kompozycjaG2_BDO_WMS/MapServer/WMSServer",
        layers: "Pokr_ter_250,Zab_250,Cieki_250,Zb_wodne_250,Morze_250,PN_250,Granice_250,Drogi_250,Kolej_250,Linie_rur_250,Stacje_250,Ob_gosp_250,Porty_250,Lotniska_250,Miejsc_250,Nr_drog_250",
        projection: "EPSG:4326"
    },
    {
        name: "osnowa",
        type: "wms",
        url: "https://mapy.geoportal.gov.pl/wss/service/pub/guest/G2_OSNOWA_WMS/MapServer/WMSServer",
        layers: "0,1,2,3,4,5,6,7",
        projection: "EPSG:4326"
    },
    {
        name: "transport",
        type: "wms",
        url: "https://mapy.geoportal.gov.pl/wss/service/pub/guest/G2_TRANSPORT_WMS/MapServer/WMSServer",
        layers: "0,1,2",
        projection: "EPSG:4326"
    }
    ],
    basemaps: [
        {
            name: "streets",
            type: "xyz",
            url: "https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1Ijoic3NnaXNzdXBwb3J0IiwiYSI6ImNpeW9mNjY1ZDAwNTAycXFxbzR2MG1hYmIifQ.3m7XLhNFS_XSqkAO5kC6mA",
        },
        {
            name: "satellite",
            type: "xyz",
            url: "https://api.mapbox.com/v4/mapbox.satellite/{z}/{x}/{y}.png?access_token=pk.eyJ1Ijoic3NnaXNzdXBwb3J0IiwiYSI6ImNpeW9mNjY1ZDAwNTAycXFxbzR2MG1hYmIifQ.3m7XLhNFS_XSqkAO5kC6mA",
        },
        {
            name: "light",
            type: "xyz",
            url: "https://api.mapbox.com/styles/v1/mapbox/light-v10/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1Ijoic3NnaXNzdXBwb3J0IiwiYSI6ImNpeW9mNjY1ZDAwNTAycXFxbzR2MG1hYmIifQ.3m7XLhNFS_XSqkAO5kC6mA",
        },
        {
            name: "osmInwestor",
            type: "xyz",
            url: "http://api.gis-support.pl/v1/maptile/map/tiles/inwestor/webmercator/{z}/{x}/{y}.png"
        }
        ,
        {
            name: "osm",
            type: "xyz",
            url: "https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        },
        {
            name: "orto",
            type: "wmts",
            url: "https://mapy.geoportal.gov.pl/wss/service/PZGIK/ORTO/WMTS/StandardResolution",
            layers: "ORTOFOTOMAPA",
            projection: 'EPSG:2180',
            CRS: "EPSG:2180",
            parameters:
            {
                matrixIds: ["EPSG:2180:0", "EPSG:2180:1", "EPSG:2180:2", "EPSG:2180:3", "EPSG:2180:4", "EPSG:2180:5", "EPSG:2180:6", "EPSG:2180:7", "EPSG:2180:8", "EPSG:2180:9", "EPSG:2180:10", "EPSG:2180:11", "EPSG:2180:12", "EPSG:2180:13", "EPSG:2180:14", "EPSG:2180:15", "EPSG:2180:16"],
                origin: [100000, 850000],
                resolutions: [8466.6836, 4233.3418, 2116.6709, 1058.33545, 529.167725, 264.5838625, 132.29193125, 66.145965625, 26.458386249999997, 13.229193124999998, 6.614596562499999, 2.645838625, 1.3229193125, 0.529167725, 0.2645838625, 0.13229193125, 0.066145965625],
                tileSize: 512,
            }
        },
    ],
    infrastructureLayers: [
        // Infrastruktura techniczna
        {
            layerName: "prad",
            label: "mapprinting.energy"
        },
        {
            layerName: "woda",
            label: "mapprinting.water"
        },
        {
            layerName: "sanit",
            label: "mapprinting.sewer"
        },
        {
            layerName: "gaz",
            label: "mapprinting.gas"
        },
        {
            layerName: "telekom",
            label: "mapprinting.teltech"
        },
        {
            layerName: "deszcz",
            label: "mapprinting.rain"
        },
        {
            layerName: "connection",
            label: "mapprinting.connection"
        },
        {
            layerName: "parking",
            label: "mapprinting.parking"
        },
        {
            layerName: "roads",
            label: "mapprinting.roads"
        },
    ],
    offersLayers: [
        // Kategoria ofert
        {
            // Tereny dostępne
            layerName: "ficzery",
            label: "legend.available"
        },
        {
            // Tereny zainwestowane
            layerName: "ficzeryZainwest",
            label: "legend.invested"
        },
        {
            // Hale przemysłowe
            layerName: "hale",
            label: "legend.halls"
        },
        {
            // Biura
            layerName: "biura",
            label: "legend.offices"
        },
    ],
    recordLayers: [
        // Ewidencja gruntów
        {
            // Działki ewidencyjne
            layerName: "dzialki",
            label: "legend.surface"
        }
    ]
}